import * as React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { compose, withHandlers } from 'recompose';
import { bindActionCreators } from 'redux';
import { goBack, goForward, push, replace } from 'redux-first-history';
import * as routerSelector from '../redux/store/router/router.selector';
function withNavigation(Comp) {
    class WrappedComponent extends React.Component {
        render() {
            return React.createElement(Comp, { ...this.props });
        }
    }
    const mapStateToProps = (state, props) => ({
        ...props,
        locationInPathSelector: routerSelector.getLocationIsInPath(state),
        locationMatchesPathSelector: routerSelector.getLocationMatchesPath(state),
        locationsFromPath: routerSelector.getLocationsFromPath(state),
        currentLastPathLocation: routerSelector.getCurrentLastPathLocation(state),
    });
    const mapDispatchToProps = (dispatch) => bindActionCreators({
        goTo: push,
        goBack: goBack,
        goForward: goForward,
        replaceUrl: replace,
    }, dispatch);
    return compose(withRouter, connect(mapStateToProps, mapDispatchToProps), withHandlers({
        goToHandler: ({ goTo, replaceUrl }) => (path, replacePath) => () => {
            if (replacePath) {
                return replaceUrl(path);
            }
            goTo(path);
        },
    }))(WrappedComponent);
}
export default withNavigation;
//# sourceMappingURL=withNavigation.js.map